
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chatgpt-product",
      function () {
        return require("private-next-pages/chatgpt-product.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/chatgpt-product"])
      });
    }
  